import { createFileRoute, useNavigate } from "@tanstack/react-router"
import {
  QUOTE_UPLOAD,
  UploadQuoteDialog,
} from "@/routes/_layout/quoting_/quotes/-components/upload-quote-dialog"

export const Route = createFileRoute("/_layout/quotes/from-file")({
  component: FromFileModal,
})

function FromFileModal(): React.ReactElement {
  const navigate = useNavigate()

  return (
    <UploadQuoteDialog
      upload={QUOTE_UPLOAD}
      onClose={() => navigate({ to: "/quotes", search: true })}
    />
  )
}
